<style lang="less" scoped>

</style>

<template lang="pug">
  #order.admin-container
    .admin-title-cover
      .admin-title 처방 관리
      .admin-options
        router-link(to="/admin/recipe/add")
          el-button(type="default" native-type="button") 처방 추가
    .admin-content-cover
      .order-list-cover
        el-table(
        :data="prescriptions"
        style="width: 100%")
          el-table-column(
            prop="name"
            label="처방명")
            template(slot-scope="scope")
              router-link(:to="`/admin/recipe/${scope.row._id}`") {{scope.row.name}}
      .tc(style="padding-top: 16px;")
        pagination(v-if='pageOption', v-bind='pageOption')

</template>

<script>
import pagination from '@/components/pagination';

const limit = 25;

export default {
  props: ['index'],
  data() {
    return {
      prescriptions: null,
      pageOption: null,
    };
  },
  methods: {
    async refreshPrescription() {
      const params = JSON.parse(JSON.stringify(this.$route.query));
      params.skip = params.page ? params.page * limit : 0;
      params.limit = limit;
      const { data } = await this.$http.get('/prescriptions', { params: params });
      return data;
    },
    async refreshPagination() {
      const totalCount = await this.$http.get('/prescriptions/count');
      const currentPage = this.$route.query.page || 0;
      return this.$pagination(currentPage * 1, limit, 5, totalCount.data);
    },
  },
  watch: {
    async $route() {
      this.pageOption = await this.refreshPagination();
      this.prescriptions = await this.refreshPrescription();
    },
  },
  async mounted() {
    this.pageOption = await this.refreshPagination();
    this.prescriptions = await this.refreshPrescription();
  },
  components: {
    pagination,
  },
};
</script>



// WEBPACK FOOTER //
// src/pages/admin/recipe.vue